import { doc, getDoc, setDoc } from 'firebase/firestore'

import { db } from 'utils/firebase'

import { ActivityType } from 'types/activityType'

import { formatDocSnapshot } from './formatFirestoreResults'

import activityTypesData from '../activityTypes.json'

export const fetchActivityTypes = async (): Promise<ActivityType> => {
  const docRef = doc(db, '_admin', 'activityTypes')
  const result = await getDoc(docRef)
  return formatDocSnapshot<ActivityType>(result)
}

export const postActivityTypes = async () => {
  const docRef = doc(db, '_admin', activityTypesData.id)
  await setDoc(docRef, { activityGroups: activityTypesData.activityGroups })
}
